<template>
    <div>
        <honorList :sport_id="sport_id"></honorList>
    </div>
</template>

<script>

import honorList from '@/components/ballsports/honor/list.vue';

export default {
    components: {
        honorList
    },
    data () {
        let self = (window.x = this)
        return {
            sport_id: 1,
        }
    },
    methods: {
    },
    mounted () {
    },
    watch: {},
    computed: {}
}
</script>